import React from 'react'

import CreateAreaCommentContainer from '../../containers/comments/create-area-comment-container'
import AreaActivityItemContainer from '../../containers/area-activities/area-activity-item-container'
import { Button, ButtonRow, FilterButton } from '../buttons'
import cx from 'classnames'

function downloadCSVButton (params, action, disabled, style = { position: 'absolute', top: '2px', right: '2px' }) {
  var label = 'Download'

  return (
    <Button
      onClick={(event) => action(params)}
      className={cx('action-button', 'download', { disabled })}
      style={style}
      disabled={disabled}
    />
  )
}

export default ({
  areaId,
  hasNextPage,
  onLoadNextPage,
  onDownloadCSV,
  activityIds,
  isFetching,
  area,
}) => {
  return (
    <div className="collection-container">
      {downloadCSVButton(area, onDownloadCSV, false, {})}
      <div className='list area-activity'>
        {activityIds.length
          ? activityIds.map(id => <AreaActivityItemContainer activityId={id} key={id} />)
          : (<p className='no-content'>{isFetching ? 'Loading...' : 'This area hasn\'t seen any activity.'}</p>)}

        {hasNextPage &&
          <div className='card load-more' onClick={onLoadNextPage}>
            Load more...
          </div>}

        <CreateAreaCommentContainer areaId={areaId} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/area-activities/area-activity.js